import { DocumentOfReceive } from "../models/DocumentOfReceive";
import { ParamSettings, MercantileType } from "../models/ParamSettings";
import { MercantileImportTemplate } from "./MercatileImportTemplate";
import { MercantileTemplateData } from "./MercantileTemplateData";
import { BarleyImportTemplate } from "./BarleyImportTemplate";
import { CornImportTemplate } from "./CornImportTemplate";
import { WheatImportTemplate } from "./WheatImportTemplate";
import { SunflowerImportTemplate } from "./SunflowerImportTemplate";
import { SoyaImportTemplate } from "./SoyaImportTemplate";
import { OiledBeetImportTemplate } from "./OiledBeetImportTemplate";
import { srpsCalculation } from "../services/SprsService";
import { Utility } from "../core/Utility";

export const getMercantileTemplate = (
  type: any,
  importing: boolean,
  data: DocumentOfReceive,
  settings: ParamSettings[]
) => {
  if (importing) {
    switch (type) {
      case MercantileType.Wheat:
        return WheatImportTemplate(prepareData(data, type, settings));
      case MercantileType.Corn:
        return CornImportTemplate(prepareData(data, type, settings));
      case MercantileType.Barley:
        return BarleyImportTemplate(prepareData(data, type, settings));
      case MercantileType.Sunflower:
        return SunflowerImportTemplate(prepareData(data, type, settings));
      case MercantileType.Soya:
        return SoyaImportTemplate(prepareData(data, type, settings));
      case MercantileType.OiledBeet:
        return OiledBeetImportTemplate(prepareData(data, type, settings));
      default:
        return MercantileImportTemplate(prepareData(data, type, settings));
    }
  }
};

const prepareData = (
  documentData: DocumentOfReceive,
  categoryType: any,
  settings: ParamSettings[]
) => {
  let date = "";
  let time = "";
  if (documentData.date) {
    if (typeof documentData.date == "string") {
      date = documentData.date;
    } else {
      documentData?.finishedDocumentFirstTime === true
        ? (date = `${
            documentData.date.getDate() < 10 ? "0" : ""
          }${documentData.date.getDate()}.${
            documentData.date.getMonth() < 9 ? "0" : ""
          }${
            1 + documentData.date.getMonth()
          }.${documentData.date.getFullYear()}`)
        : (date = `${
            new Date().getDate() < 10 ? "0" : ""
          }${new Date().getDate()}.${new Date().getMonth() < 9 ? "0" : ""}${
            1 + new Date().getMonth()
          }.${new Date().getFullYear()}`);
    }
  }
  if (documentData.time) {
    if (typeof documentData.time == "string") {
      time = documentData.time;
    } else {
      documentData?.finishedDocumentFirstTime === true
        ? (time = `${
            documentData.time.getHours() < 10 ? "0" : ""
          }${documentData.time.getHours()}:${
            documentData.time.getMinutes() < 10 ? "0" : ""
          }${documentData.time.getMinutes()}`)
        : (time = `${
            new Date().getHours() < 10 ? "0" : ""
          }${new Date().getHours()}:${
            new Date().getMinutes() < 10 ? "0" : ""
          }${new Date().getMinutes()}`);
    }
  }

  const docDate = Utility.parseDocDate(documentData.date);
  const cutoff = new Date(2026, 0, 14);

  const templateData: MercantileTemplateData = {
    receptionCode: documentData.documentId ?? "",
    finishedId:
      documentData?.finishedDocumentNumber ??
      documentData.finishedDocumentId ??
      "",
    documentNumber: documentData.id ?? "",
    warehouse: documentData.warehouse?.name ?? "",
    date: date,
    time: time,
    warehouseman: documentData.warehouseman as string,
    /*****Vlasnik/Dobavljac robe******/
    supplierType: documentData.partner?.type ?? "",
    supplierDeliveryNote: "12155151",
    supplierName: documentData.partner?.name ?? "",
    supplierPlace: documentData.partner?.city?.name
      ? documentData.partner?.city?.name
      : "",
    supplierAddress: documentData.partner?.address ?? "",
    supplierIdentificationNumber: documentData.partner?.companyNumber ?? "",
    supplierPib: documentData.partner?.vatNumber ?? "",
    supplierPersonalCodeNumber: documentData.partner?.personalCodeNumber ?? "",
    supplierCode: documentData.partner?.code ?? "",
    /*****supplierDeliveryNotesupplierPib*****/
    buyerName: "RWA Srbija doo",
    buyerPlace:
      docDate && docDate.getTime() >= cutoff.getTime()
        ? "21201 Rumenka"
        : "11070 Bovi Beograd",
    buyerAddress:
      docDate && docDate.getTime() >= cutoff.getTime()
        ? "Kisački put 3G"
        : "Bulevar Zorana Đinđića 67/17",
    buyerIdentificationNumber: "20405112",
    buyerPib: "105528683",
    /*****Podaci o predatoj robi, prevozniku i vozaču******/
    typeOfGoods: documentData.product?.category?.name ?? "",
    codeAndNameOfGoods: documentData.product?.name ?? "",
    shipperName: documentData.shipper?.name ?? "",
    shipperType: documentData.shipper?.type ?? "",
    shipperPlace: documentData.shipper?.city?.name
      ? documentData.shipper?.city?.name
      : "",
    shipperAddress: documentData.shipper?.address ?? "",
    shipperIdentificationNumber: documentData.shipper?.companyNumber ?? "",
    shipperPib: documentData.shipper?.vatNumber ?? "",
    shipperPersonalCodeNumber: documentData.shipper?.personalCodeNumber ?? "",
    driverName: documentData.driverName ?? "",
    licensePlates: (documentData.vehicleNumber ?? "").toUpperCase(),
    note:
      (documentData.foreignProduct ? "TUĐA ROBA " : "") +
      (documentData.note ?? ""),
    /*******Tudja roba na skladistenju *******/
    foreignProduct: documentData.foreignProduct ? "Da" : "Ne",
    productOwnerName: documentData.partner?.name ?? "",
    productOwnerPlace: documentData.partner?.city?.name
      ? documentData.partner?.city?.name
      : "",
    productOwnerAddress: documentData.partner?.address ?? "",
    productOwnerType: documentData.partner?.type ?? "",
    productOwnerIdentificationNumber: documentData.partner?.companyNumber ?? "",
    productOwnerPib: documentData.partner?.vatNumber ?? "",
    productOwnerPersonalCodeNumber:
      documentData.partner?.personalCodeNumber ?? "",
    /*******Vlaga i laboratorija******/
    bruto: documentData.brutto ?? 0,
    tara: documentData.tara ?? 0,
    neto:
      documentData.brutto !== undefined && documentData.tara !== undefined
        ? documentData.brutto - documentData.tara
        : 0,
    moisture: documentData?.moisture ?? 0,
    impurities: documentData.impurity ?? 0,
    defect: documentData.defect ?? 0,
    breaking: documentData.breakage ?? 0,
    hectolitres: documentData.hectoliter ?? 0,
    protein: documentData.protein ?? 0,
    gluten: documentData.gluten ?? 0,
    hybridVariety: documentData.hybrid ?? "",
    cellNumberfloorWarehouse: documentData.cellNumberFloor ?? "",
    /*********Calculation*********/
    accountingQuantity: "0",
    rawConsumption: "0",
    deductionOrAdditionToMoisturePercent:
      documentData.moisture === undefined || documentData.moisture === 0
        ? 0
        : srpsCalculation(
            categoryType ?? "",
            documentData.brutto !== undefined && documentData.tara !== undefined
              ? documentData.brutto - documentData.tara
              : 0,
            documentData?.moisture ?? 0,
            documentData.impurity ?? 0,
            documentData.breakage ?? 0,
            documentData.defect ?? 0,
            documentData.hectoliter as number,
            documentData.calculationMethod as boolean,
            settings
          )[1],
    deductionOrAdditionToMoistureQuantity:
      documentData.moisture === undefined || documentData.moisture === 0
        ? 0
        : srpsCalculation(
            categoryType ?? "",
            documentData.brutto !== undefined && documentData.tara !== undefined
              ? documentData.brutto - documentData.tara
              : 0,
            documentData?.moisture ?? 0,
            documentData.impurity ?? 0,
            documentData.breakage ?? 0,
            documentData.defect ?? 0,
            documentData.hectoliter as number,
            documentData.calculationMethod as boolean,
            settings
          )[2],
    deductionOrAdditionOfImpuritiesPercent:
      documentData.impurity === undefined || documentData.impurity === 0
        ? 0
        : srpsCalculation(
            categoryType ?? "",
            documentData.brutto !== undefined && documentData.tara !== undefined
              ? documentData.brutto - documentData.tara
              : 0,
            documentData?.moisture ?? 0,
            documentData.impurity ?? 0,
            documentData.breakage ?? 0,
            documentData.defect ?? 0,
            documentData.hectoliter as number,
            documentData.calculationMethod as boolean,
            settings
          )[3],
    deductionOrAdditionOfImpuritiesQuantity:
      documentData.impurity === undefined || documentData.impurity === 0
        ? 0
        : srpsCalculation(
            categoryType ?? "",
            documentData.brutto !== undefined && documentData.tara !== undefined
              ? documentData.brutto - documentData.tara
              : 0,
            documentData?.moisture ?? 0,
            documentData.impurity ?? 0,
            documentData.breakage ?? 0,
            documentData.defect ?? 0,
            documentData.hectoliter as number,
            documentData.calculationMethod as boolean,
            settings
          )[4],
    srps: srpsCalculation(
      categoryType ?? "",
      documentData.brutto !== undefined && documentData.tara !== undefined
        ? documentData.brutto - documentData.tara
        : 0,
      documentData?.moisture ?? 0,
      documentData.impurity ?? 0,
      documentData.breakage ?? 0,
      documentData.defect ?? 0,
      documentData.hectoliter as number,
      documentData.calculationMethod as boolean,
      settings
    )[0],
    diferenceReceptionDelivery:
      documentData.sentQuantity !== undefined
        ? srpsCalculation(
            categoryType ?? "",
            documentData.brutto !== undefined && documentData.tara !== undefined
              ? documentData.brutto - documentData.tara
              : 0,
            documentData?.moisture ?? 0,
            documentData.impurity ?? 0,
            documentData.breakage ?? 0,
            documentData.defect ?? 0,
            documentData.hectoliter as number,
            documentData.calculationMethod as boolean,
            settings
          )[0] - documentData.sentQuantity
        : 0,
    netoDelivery: (documentData.sentQuantity as number) ?? "",
    externalDeliveryNoteNumber: documentData.shippingSlip ?? "",
    deductionOrAdditionOnHektolitresPercent: srpsCalculation(
      categoryType ?? "",
      documentData.brutto !== undefined && documentData.tara !== undefined
        ? documentData.brutto - documentData.tara
        : 0,
      documentData?.moisture ?? 0,
      documentData.impurity ?? 0,
      documentData.breakage ?? 0,
      documentData.defect ?? 0,
      documentData.hectoliter as number,
      documentData.calculationMethod as boolean,
      settings
    )[5],
    deductionOrAdditionOnHektolitresQuantity: srpsCalculation(
      categoryType ?? "",
      documentData.brutto !== undefined && documentData.tara !== undefined
        ? documentData.brutto - documentData.tara
        : 0,
      documentData?.moisture ?? 0,
      documentData.impurity ?? 0,
      documentData.breakage ?? 0,
      documentData.defect ?? 0,
      documentData.hectoliter as number,
      documentData.calculationMethod as boolean,
      settings
    )[6],
    deductionOrAdditionOfBreakagePercent:
      documentData.breakage === undefined || documentData.breakage === 0
        ? 0
        : srpsCalculation(
            categoryType ?? "",
            documentData.brutto !== undefined && documentData.tara !== undefined
              ? documentData.brutto - documentData.tara
              : 0,
            documentData?.moisture ?? 0,
            documentData.impurity ?? 0,
            documentData.breakage ?? 0,
            documentData.defect ?? 0,
            documentData.hectoliter ?? 0,
            documentData.calculationMethod as boolean,
            settings
          )[7],
    deductionOrAdditionOfBreakageQuantity:
      documentData.breakage === undefined || documentData.breakage === 0
        ? 0
        : srpsCalculation(
            categoryType ?? "",
            documentData.brutto !== undefined && documentData.tara !== undefined
              ? documentData.brutto - documentData.tara
              : 0,
            documentData?.moisture ?? 0,
            documentData.impurity ?? 0,
            documentData.breakage ?? 0,
            documentData.defect ?? 0,
            documentData.hectoliter as number,
            documentData.calculationMethod as boolean,
            settings
          )[8],
    deductionOrAdditionOnDefectPercent:
      documentData.defect === undefined || documentData.defect === 0
        ? 0
        : srpsCalculation(
            categoryType ?? "",
            documentData.brutto !== undefined && documentData.tara !== undefined
              ? documentData.brutto - documentData.tara
              : 0,
            documentData?.moisture ?? 0,
            documentData.impurity ?? 0,
            documentData.breakage ?? 0,
            documentData.defect ?? 0,
            documentData.hectoliter as number,
            documentData.calculationMethod as boolean,
            settings
          )[9],
    deductionOrAdditionOnDefectQuantity:
      documentData.defect === undefined || documentData.defect === 0
        ? 0
        : srpsCalculation(
            categoryType ?? "",
            documentData.brutto !== undefined && documentData.tara !== undefined
              ? documentData.brutto - documentData.tara
              : 0,
            documentData.moisture as number,
            documentData.impurity ?? 0,
            documentData.breakage ?? 0,
            documentData.defect ?? 0,
            documentData.hectoliter as number,
            documentData.calculationMethod as boolean,
            settings
          )[10],
    //dryingCosts: documentData.dryingCosts as number ?? 0,
    dryingCosts: srpsCalculation(
      categoryType ?? "",
      documentData.brutto !== undefined && documentData.tara !== undefined
        ? documentData.brutto - documentData.tara
        : 0,
      documentData?.moisture ?? 0,
      documentData.impurity ?? 0,
      documentData.breakage ?? 0,
      documentData.defect ?? 0,
      documentData.hectoliter as number,
      documentData.calculationMethod as boolean,
      settings
    )[11],
    dryGrainAvailable:
      srpsCalculation(
        categoryType ?? "",
        documentData.brutto !== undefined && documentData.tara !== undefined
          ? documentData.brutto - documentData.tara
          : 0,
        documentData?.moisture ?? 0,
        documentData.impurity ?? 0,
        documentData.breakage ?? 0,
        documentData.defect ?? 0,
        documentData.hectoliter as number,
        documentData.calculationMethod as boolean,
        settings
      )[0] - //(documentData.dryingCosts as number ?? 0),
      srpsCalculation(
        categoryType ?? "",
        documentData.brutto !== undefined && documentData.tara !== undefined
          ? documentData.brutto - documentData.tara
          : 0,
        documentData?.moisture ?? 0,
        documentData.impurity ?? 0,
        documentData.breakage ?? 0,
        documentData.defect ?? 0,
        documentData.hectoliter as number,
        documentData.calculationMethod as boolean,
        settings
      )[11],
    dispersal: srpsCalculation(
      categoryType ?? "",
      documentData.brutto !== undefined && documentData.tara !== undefined
        ? documentData.brutto - documentData.tara
        : 0,
      documentData?.moisture ?? 0,
      documentData.impurity ?? 0,
      documentData.breakage ?? 0,
      documentData.defect ?? 0,
      documentData.hectoliter as number,
      documentData.calculationMethod as boolean,
      settings
    )[12],
    loadingCityName: documentData.loadingCityName ?? "",
    loadingContact: documentData.loadingContact ?? "",
  };

  return templateData;
};
